/* Copyright (c) 2020 IceRock MAG Inc. Use of this source code is governed by the Apache 2.0 license. */
/* eslint-disable jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions */

import React, { FC, useCallback } from 'react';
import { FormControl, FormHelperText, TextField } from '@material-ui/core';
import { observer } from 'mobx-react';
import { IEntityFieldProps } from 'icerockdev-admin-toolkit';
import { Autocomplete } from '@material-ui/lab';

const EntityFieldReferenceSelect: FC<IEntityFieldProps> = observer(
  ({ label, name, value, handler, error, isEditing, onClick, entity, options }) => {
    const emptyNode = <div>-</div>;

    if (!entity) {
      return emptyNode;
    }

    const menuItems: Record<string, any> =
      (options && Object.keys(options).length !== 0 ? options : entity.referenceData[name]) ?? {};

    const arrOption = Object.keys(menuItems).reduce(
      (prev, item) => {
        prev.push({ id: item, label: menuItems[item] });
        return prev;
      },
      [{ id: '', label: '' }]
    );
    arrOption.shift();

    const defaultProps = {
      options: arrOption,
      getOptionLabel: (option: { id: string; label: string }) => option?.label,
    };

    const onChange = useCallback(
      (event) => {
        if (!handler) return;
        if (event) {
          handler(event?.id);
        }
      },
      [handler]
    );

    return isEditing ? (
      <FormControl variant="outlined">
        <Autocomplete
          {...defaultProps}
          id="combo-box"
          autoHighlight
          onChange={(event: any, newValue: { id: string; label: string } | null | undefined) => {
            onChange(newValue);
          }}
          renderInput={(params) => <TextField {...params} variant="outlined" label={label} />}
        />
        <FormHelperText error={!!error}>{error}</FormHelperText>
      </FormControl>
    ) : (
      <div onClick={onClick}>{(menuItems && menuItems[value]) || emptyNode}</div>
    );
  }
);

export { EntityFieldReferenceSelect };
